export default __webpack_public_path__ + "static/media/e-signatures_original.6b9378ee.png";